import React, { useEffect, useMemo } from "react";
import styled from "styled-components";
import { authType } from "../../../recoil/auth";
import { getLangWord, langText } from "../../../recoil/lang";
import { ThemeType } from "../../../recoil/theme";

interface HeaderProps {
  name: string;
  lang: number;
  navigate: any;
  visibleLanguage: boolean;
  setVisibleLanguage: React.Dispatch<React.SetStateAction<boolean>>;
  theme: ThemeType;
}

const Header = ({
  name,
  lang,
  navigate,
  visibleLanguage,
  setVisibleLanguage,
  theme,
}: HeaderProps) => {
  // navigate
  const navigateOrderStatus = () => {
    navigate(`/status`);
  };

  const Header = useMemo(() => {
    return (
      <Style>
        <div className="header">
          <div className="buttonWrap">
            {theme.logo && (
              <button className="logoButton">
                <img
                  src={theme.logo}
                  className="logoButton"
                  alt="knockkonck로고"
                />
              </button>
            )}
            <h3>{name}</h3>
            {theme.area_name && <img src={theme.area_name} alt="areaIcon" />}
          </div>
          <div className="buttonWrap">
            <button className="longButton" onClick={navigateOrderStatus}>
              {theme.order_status && (
                <img
                  className="bell"
                  src={theme.order_status}
                  alt="orderStatus"
                />
              )}
              <h5>{langText.storeSelector_orderStatus[lang]}</h5>
            </button>
            <button
              className="longButton"
              onClick={() => setVisibleLanguage(!visibleLanguage)}
            >
              <img
                src={`${
                  process.env.PUBLIC_URL
                }/knockknock/svg/lang/ic_lang_${getLangWord(lang)}.svg`}
                alt="lang"
              />
              <h5>Language</h5>
            </button>
          </div>
        </div>
      </Style>
    );
  }, [name, lang]);

  return Header;
};
export default Header;

const Style = styled.div`
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: sticky;
    top: 0;
    padding: 8px 14px;
    background: #000;
    z-index: 5;
  }
  .buttonWrap {
    display: flex;
    align-items: center;
    gap: 6px;
    h3 {
      font-size: 14px;
      line-height: 20px;
      font-weight: 400;
      color: #ffffff;
    }
    img {
      max-height: 28px;
      margin-left: -4px;
    }

    .logoButton {
      width: 14vw;
      padding: 0;
      margin: 0;
      img {
        width: 100%;
        height: 100%;
        max-height: none;
        object-fit: contain;
      }
    }
    .longButton {
      max-width: 36vw;
      padding: 4px 10px;
      border-radius: 50px;
      border: 1px solid #555555;
      background: #262626;
      display: flex;
      align-items: center;
      gap: 6px;
      cursor: pointer;
      img {
        height: 16px;
      }
      img.bell {
        height: 20px;
        margin-top: -8px;
      }
      h5 {
        color: #ffffff;
        font-size: 10px;
        line-height: 20px;
        font-weight: 400;
        white-space: normal;
      }
    }
  }
`;
